export default "__VITE_ASSET__DkiyO_hd__"